import { gql } from '@apollo/client';

// We must always include version with content so Apollo cache
// does not go out of sync
const POST_CONTENT_FRAGMENT = gql`
  fragment PostContent on PublicPostFields {
    content
    version
  }
`;

export default POST_CONTENT_FRAGMENT;
